import React, { useEffect } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import { StepIconProps } from '@material-ui/core';
import StepLabel from "@material-ui/core/StepLabel";
import SettingsIcon from "@material-ui/icons/Settings";
import clsx from "clsx";
import { MdDirectionsRun } from 'react-icons/md';
import { FaCheck } from 'react-icons/fa';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      paddingTop: '3em'
    },
    button: {
      marginRight: theme.spacing(1),
    },
    backButton: {
      marginRight: theme.spacing(1),
    },
    completed: {
      display: 'inline-block',
    },
    active: {
      backgroundImage:
        'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  }),
);

function getSteps() {
  return [
    'Pedido realizado',
    'Pedido aprovado comercial',
    'Pedido aprovado crédito',
    'Inicio de coleta',
    'Pedido coletado',
    'Pedido faturado',
    'Pedido em transporte',
    'Entrega realizada'
  ];
}

interface HistPedido {
  dateve: string,
  deseve: string,
  esteve: string,
  horeve: string
}

interface arrayHistPedidos {
  forEach: any;
  length: number;
  [index: number]: HistPedido
}

export function TimelineConsultaPedidos(props: { historico: arrayHistPedidos }) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState(new Set<number>());
  const steps = getSteps();

  useEffect(() => {
    let positionArray
    let newCompleted = new Set(completed);
    props.historico.forEach((item: any) => {
      console.error(item.deseve);
      positionArray = getSteps().indexOf(item.deseve);
      if (positionArray >= 0 && item.esteve.toLowerCase() === "ok") {
        newCompleted.add(positionArray);
        setCompleted(newCompleted);
      }
      if (positionArray >= 0 && item.esteve.toLowerCase() === "andamento") {
        setActiveStep(positionArray);
      }
    })
  }, []);

  const useStyleIconAndamento = makeStyles({
    root: {
      backgroundColor: "#0252a8",
      zIndex: 1,
      color: "white",
      width: 30,
      height: 30,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
      marginTop: '-0.2em',
      fontWeight: 'bold'
    },
    active: {
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    },
    completed: {
      backgroundImage:
        "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)"
    }
  });

  const useStyleIconConcluido = makeStyles({
    root: {
      backgroundColor: "green",
      zIndex: 1,
      color: "#fff",
      width: 30,
      height: 30,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
      marginTop: '-0.2em',
      fontWeight: 'bold'
    },
    active: {
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)"
    },
    completed: {
      backgroundImage:
        "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)"
    }
  });

  const useStyleIconPendente = makeStyles({
    root: {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#fff",
      width: 30,
      height: 30,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
      marginTop: '-0.2em',
      fontWeight: 'bold'
    },
    active: {
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)"
    },
    completed: {
      backgroundImage:
        "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)"
    }
  });

  function IconAndamento(props: StepIconProps) {
    const classes = useStyleIconAndamento();
    const { active, completed } = props;

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed
        })}
      >
        <MdDirectionsRun size={20} />
      </div>
    );
  }

  function IconConcluido(props: StepIconProps) {
    const classes = useStyleIconConcluido();
    const { active, completed } = props;

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed
        })}
      >
        <FaCheck size={13} style={{marginTop: '0.1em', marginLeft: '0.1em'}}/>
      </div>
    );
  }

  function IconPendente(props: StepIconProps) {
    const classes = useStyleIconPendente();
    const { active, completed } = props;

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed
        })}
      >
        <></>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Stepper alternativeLabel nonLinear activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          return (
            <Step key={label} {...stepProps}>
              <div style={{ position: 'absolute', width: '100%', top: '-3.5em', textAlign: 'center', fontWeight: 'bold', boxSizing: 'content-box', marginLeft: '-0.5em' }}>
                {props.historico[index].esteve === "andamento" ?
                  "Em andamento"
                  :
                  props.historico[index].dateve !== "." ? props.historico[index].dateve : ""}
                <br />
                {props.historico[index].dateve !== "." ? props.historico[index].horeve : ""}
              </div>
                {props.historico[index].esteve === "andamento" &&
                  <StepLabel StepIconComponent={IconAndamento}>{label}</StepLabel>
                }
                {props.historico[index].esteve === "ok" &&
                  <StepLabel StepIconComponent={IconConcluido}>{label}</StepLabel>
                }
                {props.historico[index].esteve === "pendente" &&
                  <StepLabel StepIconComponent={IconPendente}>{label}</StepLabel>
                }
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}
